import Component from '@glimmer/component';

export default class PageCellSimpleContentComponent extends Component {
  get valueOrSlashDisplay() {
    const value = this.args.page?.[this.args.field];
    return !value ? '/' : value;
  }
}
